import { H3, H4 } from '@dnb/eufemia';
import styled from '@emotion/styled';

import { mq } from './Api.global.styles';

export const StyledApiDocumentationPage = styled.div`
  grid-template-columns: auto;
  display: grid;
  background-color: ${(props) => props?.theme?.colors.backgroundDocumentation};

  .dnb-skeleton & .content {
    * {
      color: transparent !important;
      border-color: var(--color-black-8) !important;
      background-color: transparent;
    }

    h1,
    h2,
    h3,
    code {
      &:not(:empty) {
        background-image: linear-gradient(var(--color-black-8) 100%, transparent 0);
        background-size: 80% 1em;
        background-repeat: no-repeat;
        background-position: left center;
        border-radius: 4px;
      }
    }

    svg {
      visibility: hidden;
    }
  }

  .content {
    width: auto;
    max-width: 960px;
    padding-bottom: calc(var(--spacing-xx-large) + var(--spacing-xx-large));
    scroll-behavior: auto;
    overflow-wrap: break-word;
    word-break: break-word;
    min-width: 0;

    ${mq['small']} {
      margin: 0 var(--spacing-medium);
    }

    ${mq['medium']} {
      margin: 0 var(--spacing-large);
    }

    .code {
      width: 100%;
      display: inline-grid;
    }

    .download {
      margin-top: var(--spacing-x-large);
      margin-bottom: var(--spacing-medium);

      span {
        margin-right: var(--spacing-xx-small);
      }
      a {
        cursor: pointer;
      }
    }
    h1 {
      font-size: var(--font-size-x-large);
      line-height: var(--line-height-basis);
      margin: var(--spacing-x-large) 0 var(--spacing-large) 0;
      font-weight: var(--font-weight-medium);
    }
    #introduction {
      p {
        margin-top: var(--spacing-large);
        margin-bottom: 0;
        font-size: var(--font-size-basis);
      }
    }
  }
`;

export const H3S = styled(H3)`
  font-size: var(--font-size-large);
  line-height: var(--line-height-lead);
  margin: var(--spacing-large) 0 var(--spacing-small) 0 !important;
`;

export const H4S = styled(H4)`
  font-size: var(--font-size-medium);
  text-transform: capitalize;
  line-height: var(--line-height-basis);
  margin: var(--spacing-large) 0 var(--spacing-small) 0 !important;
`;
